export class Step3 {
	public intitule = 'stepper.form.simp_in.step3';

	public getoui = 'form.simp_in.getoui';
	public getnon = 'form.simp_in.getnon';
	public getspan17 = 'form.simp_in.getspan17';
	public getspan18 = 'form.simp_in.getspan18';
	public getspan19 = 'form.simp_in.getspan19';
	public getspan20 = 'form.simp_in.getspan20';
	public getspan21 = 'form.simp_in.getspan21';
	public getspan22 = 'form.simp_in.getspan22';
	public getspan23 = 'form.simp_in.getspan23';

	public champIntitule = 'form.simp_in.getintitule';
	public classPrincipale = 'form.simp_in.getclassprincipale';
	public classSupplementaire = 'form.simp_in.getclasssupplementaire';
	public description = 'form.simp_in.getdescription';
	public travaux = 'form.simp_in.gettravaux';
	public fournitures = 'form.simp_in.getfournitures';
	public services = 'form.simp_in.getservices';
	public num = 'form.simp_in.getnum';
	public typevoie = 'form.simp_in.gettypevoie';
	public nomvoie = 'form.simp_in.getnomvoie';
	public ville = 'form.simp_in.getville';
	public cp = 'form.simp_in.getcp';
	public dureeMois = 'form.simp_in.getdureemois';
	public valeurEstimee = 'form.simp_in.getvaleurestimee';
	public entrepriseAdaptee = 'form.simp_in.getentrepriseadaptee';
	public servicesSociaux = 'form.simp_in.getservicessociaux';
	public structureInsertion = 'form.simp_in.getstructureinsertion';
	public valeur = 'form.simp_in.getvaleurhtva';
	public devise = 'form.simp_in.getdevise';
	public valeurBasse = 'form.simp_in.getvaleurbasse';
	public valeurHaute = 'form.simp_in.getvaleurhaute';

	constructor() {}
}
